import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputPasswordComponent} from './input-password.component';
import {FormsModule} from '@angular/forms';
import {IconModule} from '@tisa-group/client-ui/components/icon';
import {InputTextModule} from '@tisa-group/client-ui/components/inputs/input-text';

@NgModule({
  declarations: [InputPasswordComponent],
  imports: [CommonModule, FormsModule, IconModule, InputTextModule],
  exports: [InputPasswordComponent],
})
export class InputPasswordModule {}
